import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

export default function PasswordRecovery() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();

  const handlePasswordResetRequest = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      // 1. Send the reset email via Supabase
      // IMPORTANT: Change the redirectTo URL to match your route for the previous page we built
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + "/reset-password", 
      });

      if (error) throw error;

      setMessage("Check your email for the password reset link.");
      
    } catch (err) {
      setError(err.message || "Failed to send recovery email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen w-full flex items-center justify-center font-sans">
      
      {/* BACKGROUND - Matching your other auth pages */}
      <div 
        className="fixed inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: `url('https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2070&auto=format&fit=crop')`, 
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-black/80 via-black/60 to-blue-900/40 backdrop-blur-[3px]"></div>
      </div>

      {/* RECOVERY CARD */}
      <div className="relative z-10 w-full max-w-[440px] px-4 py-8">
        <div className="bg-white/10 backdrop-blur-2xl border border-white/20 p-8 md:p-12 rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.3)]">
          
          <div className="text-center mb-8">
            <h1 className="text-3xl font-black text-white tracking-tighter italic uppercase">
              Account Recovery<span className="text-blue-500">.</span>
            </h1>
            <p className="text-gray-400 text-xs mt-2 uppercase tracking-widest font-bold">
              We'll send you a secure link
            </p>
          </div>

          {error && (
            <div className="bg-red-500/10 border border-red-500/50 text-red-400 p-4 rounded-2xl text-xs mb-6 font-bold flex items-center gap-2">
              ⚠️ {error}
            </div>
          )}

          {message && (
            <div className="bg-green-500/10 border border-green-500/50 text-green-400 p-4 rounded-2xl text-xs mb-6 font-bold">
              ✅ {message}
            </div>
          )}

          {!message && (
            <form onSubmit={handlePasswordResetRequest} className="space-y-5">
              <div className="space-y-2">
                <label className="text-[11px] font-black text-gray-400 uppercase tracking-widest ml-1">
                  Registered Email
                </label>
                <input
                  type="email"
                  placeholder="athlete@performance.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-black/20 border border-white/10 rounded-2xl p-4 text-white placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-blue-500/50 transition-all"
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-white hover:bg-blue-600 text-black hover:text-white font-black py-4 rounded-2xl transition-colors duration-200 active:scale-[0.98] disabled:opacity-50 mt-4 uppercase tracking-widest shadow-lg"
              >
                {loading ? "Sending Link..." : "Send Recovery Link"}
              </button>
            </form>
          )}

          <div className="pt-6 text-center">
            <button
              type="button"
              className="text-gray-400 hover:text-white text-[11px] font-bold uppercase tracking-widest transition"
              onClick={() => navigate("/login")}
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}